/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.phone" placeholder="输入用户名或手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" 
    :data="listData" 
    highlight-current-row 
    v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="40">
      </el-table-column>
      <el-table-column  prop="user_id" label="ID" width="60" >
      </el-table-column>
      <el-table-column  prop="username" label="用户名" width="100">
      </el-table-column>
      <el-table-column  prop="phone" label="手机号" width="100">
      </el-table-column>
      <el-table-column  prop="create_time" label="注册时间" width="auto">
      </el-table-column>
      <el-table-column  label="是否开通vip" width="100" >
        <template slot-scope="{row}">
          <div v-if="row.pay == 1"  >{{ row.Opened }}</div>
          <div v-else  >未开通</div>
        </template>
      </el-table-column>
      <el-table-column  prop="pay_time" label="会员到期时间" width="auto">
      </el-table-column>
      <el-table-column  prop="card_pwd" label="卡密" width="auto">
      </el-table-column>
      <el-table-column  prop="editUser" label="备注" width="auto">
      </el-table-column>
      <el-table-column  prop="trainer_name" label="教练" width="60">
      </el-table-column>
      <el-table-column  prop="amount" label="积分" width="auto">
      </el-table-column>
      <el-table-column  prop="open" label="注册平台" width="80">
      </el-table-column>
      <!-- <el-table-column align="center" label="操作" min-width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="info" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini"  type="primary" @click="deleteUser(scope.$index, scope.row)">查看</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
import { getuserList, deptSave, deptDelete } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },
      formInline:{
        phone:'',
        page:1
      },
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  created() {
    this.getdata(this.formInline)
    this.generateBreadcrumb()
  },
  methods: {
    generateBreadcrumb() {
      // 获取当前路由信息
      const matched = this.$route.matched
      console.log(matched,'++++++++++');
      // 初始化面包屑导航数据
      const breadcrumbList = []
      // 遍历路由信息，生成面包屑导航数据
      matched.forEach(item => {
        const { meta, name, path } = item
        if (meta.requireAuth) {
          breadcrumbList.push({
            name,
            path
          })
        }
      })
      console.log(breadcrumbList,'=========');
      // 保存面包屑导航数据
      this.breadcrumbList = breadcrumbList
    },
    // 获取公司列表
    getdata(formInline) {
      this.loading = true
      getuserList(formInline).then(res => {
          console.log(res);
          if(res.code == 200){
            this.listData = res.user_info.data
            this.pageparm.total = res.user_info.total
            this.loading = false
          }
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.page = 1
      this.getdata(this.formInline)
    },
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/index/Index.vue